import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type HelpCenterSettingsSidebarType from './ui/index.tsx';

export const LazyHelpCenterSettingsSidebar = lazyAfterPaint<typeof HelpCenterSettingsSidebarType>(
	() => {
		setPerformanceMarkLoadStart();

		return import(/* webpackChunkName: "async-sidebar-help-center-settings" */ './index').then(
			(bundle) => {
				setPerformanceMarkLoadEnd();
				return bundle;
			},
		);
	},
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const HelpCenterSettingsSidebar = memo<Record<any, any>>(() => (
	<SidebarBoundary id="servicedeskProject">
		<LazyHelpCenterSettingsSidebar />
	</SidebarBoundary>
));

HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';

export default HelpCenterSettingsSidebar;
